export default __webpack_public_path__ + "static/mob-img03-b89a0e233e12589502ab25d84235cdbe.png";